<template lang="pug">
    div
        BreadCrumb(:linkBreadCrumb="linkBreadCrumb")
        manager-wholesale-discounts(submitText="Crear esquema" crudOption="create"
            @clear-form="clearForm"
            @submit-form="submitForm"
            @cancel-editing="returnPreviousRoute"
            )
            div
                subfamily-data
</template>

<script>
import { BreadCrumb } from '@/components/reusable_components'
import InputValidations from '@/mixins/InputValidations.js'
import CurrencyUtils from '@/mixins/CurrencyUtils.js'
import ManagerWholesaleDiscounts from '@/components/WholesaleDiscount/Manager'
import SnackbarModalUtils from '@/mixins/SnackbarModalUtils'
import SubfamilyData from './SubfamilyData'

import SubfamilyWholesaleDiscountService from '@/services/api/subfamily/SubfamilyWholesaleDiscountService'
import { mapActions, mapState } from 'vuex'
export default {
    name: 'component-name',
    props: {},
    data: function() {
        return {
            linkBreadCrumb: [
                {
                    text: 'Listado Familias',
                    disabled: false,
                    to: `/families`,
                    exact: true,
                },
                {
                    text: 'Familia',
                    disabled: false,
                    to: `/families/${this.$route.params.id}`,
                    exact: true,
                },
                {
                    text: 'Subfamiia',
                    disabled: false,
                    to: `/families/${this.$route.params.id}/subfamilies/${this.$route.params.id_subfamily}`,
                    exact: true,
                },
                {
                    text: 'Creación Esquema descuentos subfamilia',
                    disabled: true,
                },
            ],
        }
    },
    computed: {
        ...mapState('WholesaleDiscountModule', {
            arrayDiscounts: 'arrayDiscounts',
            id: 'id',
            globalPercentageDiscount: 'globalPercentageDiscount',
        }),
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        ...mapActions('WholesaleDiscountModule', {
            resetArrayDiscounts: 'resetArrayDiscounts',
            addDiscount: 'addDiscount',
            resetStateWholesaleDiscount: 'resetState',
            setGlobalPercentageDiscount: 'setGlobalPercentageDiscount',
            setId: 'setId',
            setMaxPriceDiscount: 'setMaxPriceDiscount',
        }),

        returnPreviousRoute() {
            this.$router.push({ path: `/familes/${this.id}` })
        },

        clearForm() {
            this.resetArrayDiscounts()
        },

        async submitForm() {
            let snackLoading = this.fillSnack(
                'info',
                'Creando',
                'Espere un momento',
                true,
                6000
            )
            this.initSnackbar(snackLoading)
            let response = await SubfamilyWholesaleDiscountService.createWholeSaleDiscounts(
                this.arrayDiscounts,
                this.id
            )
            if (response.status == 'success') {
                let snackInfo = this.fillSnack(
                    'success',
                    'Éxito',
                    'El esquema de descuentos se ha guardado exitosamente',
                    false,
                    6000
                )
                this.initSnackbar(snackInfo)
                let id_subfamily = this.$route.params.id_subfamily
                this.$router.push({
                    path: `/families/${this.id}/subfamilies/${id_subfamily}`,
                })
            } else {
                //TODO: test response error from backend
                let snackInfo = this.fillSnack(
                    'error',
                    'Error',
                    response,
                    false,
                    3000
                )
                this.initSnackbar(snackInfo)
            }
        },
    },
    watch: {},
    components: { ManagerWholesaleDiscounts, SubfamilyData, BreadCrumb },
    mixins: [InputValidations, CurrencyUtils, SnackbarModalUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    beforeMount: async function() {
        let idFamily = this.$route.params.id
        let id = this.$route.params.id_subfamily
        let whDiscounts = await SubfamilyWholesaleDiscountService.fetchWholesaleDiscountsSubfamily(
            id
        )
        if (whDiscounts === null || whDiscounts.length === 0) {
            // Wholesale discounts should be created
            await this.resetStateWholesaleDiscount()
            this.setGlobalPercentageDiscount(true)
            this.addDiscount()
            this.setId(id)
            this.setMaxPriceDiscount(100)
            // this.setId(id)
            // this.setGlobalPercentageDiscount(true)
            // this.addDiscount()
        } else {
            // Wholesale discounts should be shown/edited
            this.$router.push({
                path: `/families/${idFamily}/subfamilies/${id}/wholesale_discounts`,
            })
        }
    },
    mounted: function() {
        this.setTitleTopBar('Crear esquema descuentos subfamilia')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_WHOLESALE_DISCOUNT_BY_SUBFAMILY'))
                ctx.$router.push('/')
        })
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>